// Copyright (c) 2016 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['isShipmentPriorityHigh', 'daysLeft'],
        sortDirection: 'DESC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/state/search-filters.js